export enum ColorSwatchSize {
  small = 'small',
  medium = 'medium',
  large = 'large'
}

export enum ColorInputSize {
  small = 'small',
  large = 'large'
}

export enum ColorType {
  solid = 'solid',
  gradient = 'gradient'
}

export enum GradientDirection {
  '0deg' = '0deg',
  '45deg' = '45deg',
  '90deg' = '90deg',
  '135deg' = '135deg',
  circle = 'circle'
}
